import { Button, Collapse, Icon, Modal, Progress, Select } from 'antd';
import React, { Component } from 'react';
import MapStep from '../../../../../components/step-import-order/components/map-step';
import lang from '../../../../../languages/en';
import { dialogSuccess } from '../../../../../services/dialog';
import handleException from './../../../../../services/handleException';
import { copyData } from './../../../../../services/helper';
import { uploadItemName } from './../../../../../utils/settingMerchant';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import './styles.css';

const Panel = Collapse.Panel;
const Option = Select.Option;

const listStep = [
    { index: 1, title: lang.item_name_import_step1 },
    { index: 2, title: lang.item_name_import_step2 },
    { index: 3, title: lang.item_name_import_step3 }
]

class StepImportOrder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            fileUpload: null,
            stepCurrent: 1,
            stepCurrentActual: 1,
            isLoading: false,
            percent: 1,
            dataImport: null,
            selectedImportOption: 1
        }
        this.copyState = copyData(this.state)
        this.runProgress;
    }

    selectImportOption = value => {
        this.setState({
            selectedImportOption: value
        })
    }

    onCancel = () => {
        let data = { ...this.copyState }
        this.clearRunProgress()

        this.setState({
            ...data
        })
    }

    onBack = () => {
        this.changeActionStep(2)
    }

    visibleStepImportOrder = (value) => {
        this.setState({
            visible: value,
            stepCurrent: 1,
            stepCurrentActual: 1,
            percent: 1
        })
    }

    clearRunProgress = () => {
        clearInterval(this.runProgress)
    }

    changeActionStep = (value) => {
        if(value === 3) {
            this.importFile().then(() => {
                this.setState({
                    stepCurrentActual: value,
                    stepCurrent: value
                })
            }).catch((err) => {
                handleException(err)
            })
        } else {
            this.setState({
                stepCurrentActual: value,
                stepCurrent: value
            })
        }
    }

    runningLoading = () => {
        this.runProgress = setInterval(() => {
            if (this.state.percent < 70) {
                this.setState({
                    percent: this.state.percent + Math.round(Math.random() * 15),
                })
            } else if (this.state.percent < 95) {
                this.setState({
                    percent: this.state.percent + 1,
                })
            } else {
                this.clearRunProgress()
            }
        }, 300)
    }

    handleLoading = (value) => {
        this.setState({
            isLoading: value
        })
    }

    loggedText = (percent) => {
        const { stepCurrent } = this.state

        if (percent === 100) {
            return <Icon type="check" />;
        } else {
            if (stepCurrent === "1" || stepCurrent === 1) {
                return "Validating"
            } else {
                return "Importing"
            }
        }
    }

    importFile = () => {
        this.handleUploadFile(true)

        const { fileUpload, selectedImportOption } = this.state
        const { channelActive } = this.props

        return new Promise((resolve, reject) => {
            uploadItemName(fileUpload, channelActive, selectedImportOption).then(res => {
                if (res.data.code === 10001) {
                    const data = res.data.data
                    this.setState({
                        dataImport: {
                            importDateTime: data.ImportDatetime,
                            channel: data.ChannelName,
                            shopName: data.ShopName,
                            addedItems: data.CreateCount,
                            updatedItems: data.EditCount,
                            deletedItems: data.DeleteCount,
                            errorCount: data.ErrorCount,
                            importResultDetails: data.ImportResultDetails,
                            faltal: data.ResultType === "Error"
                        }
                    }, () => {
                        if(data.ErrorCount === 0) {
                            dialogSuccess({ message: lang.file_import_success })
                        }

                        resolve('done')
                    })
                } else {
                    handleException(res)
                    reject('fail')
                }
                this.props.selectChannel(this.props.channelActive)
                this.handleUploadFile(false)
            }).catch(err => {
                this.props.selectChannel(this.props.channelActive)
                this.handleUploadFile(false)
                handleException(err)
                reject('fail')
            })
        })
    }

    handleUploadFile = (value) => {
        this.handleLoading(value)
        if (value) {
            this.runningLoading()
        } else {
            this.clearRunProgress()
        }
    }

    onChangeUploadFile = file => {
        this.setState({
            fileUpload: file
        })
    }

    dropHandler = (e) => {
        this.uploadFileRef.dropHandler(e)
    }

    dragOverHandler = (e) => {
        this.uploadFileRef.dragOverHandler(e)
    }

    onChangeCollapse = (e) => {
        this.clearRunProgress()
        this.setState({
            stepCurrent: e === undefined ? undefined : e,
            percent: 1
        })
    }

    render() {
        const { stepCurrentActual, stepCurrent, dataImport, isLoading, percent, fileUpload } = this.state
        const isStep1 = stepCurrent === 1 || stepCurrent === '1'

        return (
            <div
                id='step-import-item-name'
                onDrop={isStep1 ? this.dropHandler : null}
                onDragOver={isStep1 ? this.dragOverHandler : null}
            >
                <Modal
                    title="ITEM MASTER IMPORT"
                    visible={this.state.visible}
                    onCancel={this.onCancel}
                    maskClosable={false}
                    className={'modal-import-item-name ' + (isLoading ? 'component-cancel-import-order-file' : '')}
                    centered={true}
                    destroyOnClose={true}
                    footer={[
                        <Button
                            disabled={isLoading}
                            key="onCancel"
                            onClick={this.onCancel}
                        >{stepCurrentActual === 3 ? 'Close' : 'Cancel'}
                        </Button>,
                    ]}
                >
                    <div className='content-step-import-order'>
                        <MapStep
                            listStep={listStep}
                            stepCurrentActual={stepCurrentActual ? stepCurrentActual.toString() : stepCurrentActual}
                        />
                        <Collapse
                            accordion
                            bordered={false}
                            activeKey={stepCurrent ? stepCurrent.toString() : stepCurrent}
                            className={'collapse-import-order ' + ('current-active-step' + stepCurrentActual)}
                            onChange={(e) => this.onChangeCollapse(e)}
                        >
                            <Panel
                                header="Step 1"
                                key={1}
                            >
                                <Step1
                                    onChangeUploadFile={this.onChangeUploadFile}
                                    mappingId={this.state.dataTypeMapping}
                                    handleUploadFile={this.handleUploadFile}
                                    changeActionStep={this.changeActionStep}
                                    ref={e => (this.uploadFileRef = e)}
                                />
                            </Panel>
                            <Panel
                                header="Step 2"
                                key={2}
                            >
                                <Step2
                                    onBack={this.onBack}
                                    fileUpload={fileUpload}
                                    changeActionStep={this.changeActionStep}
                                    selectImportOption={this.selectImportOption}
                                />
                            </Panel>
                            <Panel
                                header="Step 3"
                                key={3}
                            >
                                {dataImport && <Step3 dataImport={dataImport} />}
                            </Panel>
                        </Collapse>
                        {isLoading && (
                            <div id='loading-upload-file-order'>
                                <Progress
                                    className='loading-progress-upload-file'
                                    type="circle"
                                    percent={percent}
                                    format={this.loggedText}
                                />
                            </div>
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}

export default StepImportOrder



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/import-panel/index.js